export default __webpack_public_path__ + "baa3c0bfa66f39c23cd33990c8155125.jpg";